/**
 * The current employee's PTO objects on the S/4 build (`PtoObject`,
 * ZC_M12_TS_PTOOBJ): WBS elements of the configured PTO project type whose
 * responsible cost center is the employee's home cost center.
 *
 * Held here, UI-free, so the grid's cell policy can treat them as PTO (exempt
 * from the no-future-date rule) without importing the OData layer.
 */
import type { TsChargeCode } from '../types/timesheet.types'

let ptoCodes: TsChargeCode[] = []
let ptoIds = new Set<string>()

export function setPtoObjectCodes(codes: readonly TsChargeCode[]): void {
  ptoCodes = [...codes]
  ptoIds = new Set(codes.map((c) => c.id))
}

export function getPtoObjectCodes(): TsChargeCode[] {
  return ptoCodes
}

export function isPtoObjectId(id: string): boolean {
  return ptoIds.has(id)
}
